/* eslint-disable max-len */
import * as React from 'react';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import PT from 'prop-types';
import classNames from 'classnames';
import logoRafael from 'assets/client/imgs/logo-rafael.png';
import logoPoweredBy from 'assets/client/imgs/logo-powered-by.png';
import logoYnet from 'assets/client/imgs/logo-ynet.png';
import Menu from './Menu';
import Socials from '../Socials';
import Container from '../Container';
import * as css from './Header.scss';

class Header extends React.PureComponent {
	static propTypes = {
		className: PT.string,
		isOnPodcast: PT.bool,
		items: PT.oneOfType([PT.shape({}), PT.arrayOf(PT.shape({}))]).isRequired,
		isExact: PT.bool,
		path: PT.string,
	};

	static defaultProps = {
		className: '',
		isOnPodcast: false,
		isExact: false,
		path: '',
	};

	state = {
		isOpen: false,
		withBg: false,
	};

	componentDidMount() {
		window.addEventListener('scroll', this.onScroll);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.onScroll);
	}

	onScroll = () => {
		const { withBg } = this.state;

		if (window.pageYOffset !== 0 && !withBg) {
			this.setState({ withBg: true });
		} else if (window.pageYOffset === 0 && withBg) {
			this.setState({ withBg: false });
		}
	};

	onHamburgerClick = () => {
		this.setState({ isOpen: true });

		document.body.style.overflow = 'hidden';
	};

	onCloseClick = () => {
		this.setState({ isOpen: false });

		document.body.style.overflow = 'scroll';
	};

	render() {
		const { className, items, isOnPodcast, path, isExact } = this.props;
		const { isOpen, withBg } = this.state;

		return (
			<div className={classNames(css.header, { [css.withBg]: withBg }, className)}>
				<div className={css.bg} />
				<Container className={css.headerContent}>
					<div className={css.rightSide}>
						<button type="button" className={classNames(css.hamburger)} onClick={this.onHamburgerClick}>
							<span className={css.hamburgerBox}>
								<span className={css.hamburgerInner} />
							</span>
						</button>
						<Socials className={css.socials} />
					</div>
					<div className={css.leftSide}>
						<div className={css.logos}>
							<a href="https://career.rafael.co.il/" className={css.rafaelLink}>
								<img src={logoRafael} alt="logoRafael" className={css.logoRafael} />
							</a>
							<a
								href="https://poweredby.yit.co.il/?utm_source=rafael.poweredby.yit.co.il&utm_medium=referral&utm_campaign=Poweredby_Rafael"
								className={css.rafaelLink}
							>
								<img src={logoPoweredBy} alt="logoPoweredBy" className={css.logoPoweredBy} />
							</a>
							<a
								href="https://ynet.co.il?utm_source=rafael.poweredby.yit.co.il&utm_medium=referral&utm_campaign=Poweredby_Rafael"
								className={css.ynetLink}
							>
								<img src={logoYnet} alt="logoYnet" className={css.logoYnet} />
							</a>
						</div>
						<TransitionGroup className={css.menuTG}>
							{isOpen && (
								<CSSTransition
									key="menu"
									timeout={350}
									classNames={{
										enter: css.menuEnter,
										enterActive: css.menuEnterActive,
										exit: css.menuExit,
										exitActive: css.menuExitActive,
									}}
								>
									<Menu
										items={items}
										onClose={this.onCloseClick}
										path={path}
										isExact={isExact}
										isOnPodcast={isOnPodcast}
									/>
								</CSSTransition>
							)}
						</TransitionGroup>
					</div>
				</Container>
			</div>
		);
	}
}

export default Header;
